import { ConfirmationModal } from '@/lib/Modals';
import { IModalContentProps } from '@/models/modals';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { stripTopicPrefix } from '../../templates/topicPrefix';
import type { EditFlowSelection } from './editFlow';

export type DeleteWorkspaceTemplateModalProps = {
  editSelection: EditFlowSelection;
  /** Parent starts the silent connector delete runner for the selected channel. */
  onDeleteConfirmed: (selection: EditFlowSelection) => void;
} & IModalContentProps;

export const DeleteWorkspaceTemplateModal: FC<DeleteWorkspaceTemplateModalProps> = ({
  editSelection,
  closeModal,
  onDeleteConfirmed,
}) => {
  const { t } = useTranslation('comuni');

  const handleConfirm = async () => {
    closeModal();
    onDeleteConfirmed(editSelection);
  };

  const displayName = stripTopicPrefix(editSelection.template.name);

  return (
    <ConfirmationModal onClose={closeModal} onConfirm={handleConfirm} confirmText='COMMON.confirm' cancelText='COMMON.cancel'>
      <h2 className='text-lg font-semibold text-primary-900'>{t('modelli.deleteConfirmTitle')}</h2>
      <p className='text-sm text-tertiary-600'>{t('modelli.deleteConfirmDescription', { name: displayName })}</p>
    </ConfirmationModal>
  );
};
